import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import { ThreeDots } from "react-loader-spinner";
import dayjs from "dayjs";
import {
  StyledTableCell,
  StyledTableRow,
  StyledTableRowHeader,
} from "../../../components/Common/Table";
import Pagination from "../../../components/Common/Table/Components/Pagination";
import { Chip } from "@mui/material";
import ModeIcon from "@mui/icons-material/Mode";

type IProps = {
  count?: number;
  rowsPerpage?: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange?: any;
  page: number;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  loading: boolean;
  data: any[];
  tableHeader: any[];
  type: string;
  handleChangeInventoryId: (id: string) => void;
};

const InventoryTableList = ({
  count = 0,
  rowsPerpage = 10,
  page = 1,
  onPageChange,
  handleChangeRowsPerPage,
  tableHeader = [],
  loading,
  data = [],
  type,
  handleChangeInventoryId,
}: IProps) => {
  return (
    <>
      <Table stickyHeader>
        <TableHead>
          <StyledTableRowHeader>
            {tableHeader?.map((item, idx) => {
              return <StyledTableCell key={idx} >{item?.name} </StyledTableCell>;
            })}
          </StyledTableRowHeader>
        </TableHead>
        <TableBody>
          {!loading &&
            data &&
            data?.map((row: any, idx: any) => (
              <StyledTableRow key={row.id} className="table_btn">
                <StyledTableCell key={row.name + idx}>
                  {row.name}
                </StyledTableCell>
                <StyledTableCell key={row.description + idx} className="w-25">
                  {row.description}
                </StyledTableCell>
                <StyledTableCell  key={row?.isActive + idx} >
                  {row?.isActive ? (
                    <Chip  label="Active" color="primary" />
                  ) : (
                    <Chip  label="Inactive" color="error" />
                  )}
                </StyledTableCell>
                <StyledTableCell key={row?.createdAt + idx}>
                  {dayjs(row?.createdAt).format("YYYY-MM-DD")}
                </StyledTableCell>
                <StyledTableCell key={row?.id + idx}>
                  <ModeIcon
                    onClick={() => handleChangeInventoryId(row)}
                    style={{
                      cursor: "pointer",
                    }}
                  />
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
      {loading && (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ThreeDots color="#1B2850" height={50} width={50} />
        </div>
      )}
      {!loading && data?.length === 0 && (
        <div
          style={{
            width: "100%",
            height: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          No Data Found
        </div>
      )}
      <Pagination
        count={count}
        rowsPerpage={rowsPerpage}
        onPageChange={onPageChange}
        page={page}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
};

export default InventoryTableList;
